import { push } from "connected-react-router";
import * as api from "api";
import ReactGA from "react-ga4";
import { fetchFarm } from "containers/Farm/_actions";
import budgetActionTypes, { fetchBudget } from "containers/Budget/_actions";

const actionTypes = {
    GET_BLOCK_REGION_BENCHMARKS: "GET_BLOCK_REGION_BENCHMARKS",
    GET_BLOCK_REGION_BENCHMARKS_SUCCESS: "GET_BLOCK_REGION_BENCHMARKS_SUCCESS",
    GET_BLOCK_REGION_BENCHMARKS_FAILURE: "GET_BLOCK_REGION_BENCHMARKS_FAILURE",
};
export default actionTypes;

export const getAnalysis =
    (farmId, analysisId, includeFeatures = false) =>
    (dispatch) => {
        const cancelActionType = `getAnalysis/${farmId}/${analysisId}`;
        return new Promise((resolve, reject) => {
            ReactGA.event({
                category: "Budget",
                action: "Get",
            });
            dispatch({ type: cancelActionType });
            dispatch(
                api.get({
                    path: `farms/${farmId}/budgets/${analysisId}?includeFeatures=${includeFeatures ? "True" : "False"}`,
                    silentMode: true,
                    onSuccess: (response) => {
                        resolve(response);
                        return [];
                    },
                    onFailure: (error) => {
                        error.handled = true;
                        reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                        return [];
                    },
                    cancelActionType,
                })
            );
        });
    };

export const createAnalysis = (budget) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Budget",
            action: "Create",
        });
        dispatch(
            api.post({
                path: `farms/${budget.farmId}/budgets`,
                content: budget,
                onSuccess: (response) => {
                    resolve(response);
                    return (dispatch) => {
                        dispatch({ type: budgetActionTypes.BUDGET_TOUCHED, payload: { budget, isNew: true } });
                        dispatch({ type: budgetActionTypes.BUDGET_SAVED, payload: budget });
                        dispatch(fetchBudget(budget.farmId, budget.id, true));
                        dispatch(push(`/app/farm/${budget.farmId}/analysis/${budget.id}`));
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [{ type: budgetActionTypes.BUDGET_SAVE_ERROR, payload: { budget, error } }];
                },
            })
        );
    });
};

export const updateAnalysis = (budget) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Budget",
            action: "Update",
        });
        dispatch(
            api.put({
                path: `farms/${budget.farmId}/budgets/${budget.id}`,
                content: budget,
                onSuccess: (response) => {
                    resolve(response);
                    const theOfflineFarm = getState().offlineFarms.find((f) => f.id === budget.farmId);
                    const theOfflineBudget = theOfflineFarm.farm.offlineBudgets.find((b) => b.id === budget.id);
                    return (dispatch) => {
                        dispatch({ type: budgetActionTypes.BUDGET_TOUCHED, payload: { budget, isSaving: true } });
                        dispatch({ type: budgetActionTypes.BUDGET_SAVED, payload: budget });
                        if (!theOfflineBudget.isPendingSave) dispatch(fetchBudget(budget.farmId, budget.id, true));
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [{ type: budgetActionTypes.BUDGET_SAVE_ERROR, payload: { budget, error } }];
                },
            })
        );
    });
};

export const replaceAnalysis = (farmId, targetAnalysisId, sourceAnalysisId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Budget",
            action: "Replace",
        });
        return dispatch(
            api.put({
                path: `farms/${farmId}/budgets/${targetAnalysisId}/replace`,
                content: {
                    farmId,
                    targetAnalysisId,
                    sourceAnalysisId,
                },
                onSuccess: (response) => {
                    resolve(response);
                    return (dispatch) => {
                        dispatch(fetchFarm(farmId, true, null));
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
            })
        );
    });
};

export const uploadXmlFarmFile = (farmId, xml, budgetType, year, name) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Farm Home",
            action: "Upload XML",
        });
        return dispatch(
            api.post({
                path: `farms/${farmId}/budgetXml/?budgetType=${budgetType}&name=${encodeURIComponent(name)}&yearEnd=${year}`,
                content: xml,
                onSuccess: (response) => {
                    resolve(response);
                    return (dispatch) => {
                        dispatch(fetchFarm(farmId, true));
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    var errors = [];
                    if (error.xhr && error.xhr.response) {
                        if (error.xhr.response.length) {
                            for (var i = 0; i < error.xhr.response.length; i++) {
                                errors.push(error.xhr.response[i].message ? error.xhr.response[i].message.text : error.xhr.response[i].errorMessage);
                            }
                        } else {
                            errors.push(error.xhr.response.error ? error.xhr.response.error + ". Please try again and if problem persists call support." : "An unexpected error has occured. Please try again or call support if the problem persists.");
                        }
                    } else {
                        errors.push("An unexpected error has occured. Please try again or call support if the problem persists.");
                    }
                    reject(errors);
                    return [];
                },
            })
        );
    });
};

export const uploadJsonFarmFile = (farmId, json, budgetType, year, name) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Farm Home",
            action: "Upload JSON",
        });
        return dispatch(
            api.post({
                path: `farms/${farmId}/analysis/loadjson?budgetType=${budgetType}&name=${encodeURIComponent(name)}&yearEnd=${year}`,
                content: json,
                onSuccess: (response) => {
                    resolve(response);
                    return (dispatch) => {
                        dispatch(fetchFarm(farmId, true));
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    var errors = [];
                    if (error.status !== 500 && error.response) {
                        if (error.response.errors && error.response.errors.length > 0) {
                            errors = error.response.errors.map((e) => e.field + ": " + e.message);
                        } else {
                            try {
                                Object.keys(error.response).forEach((e) => {
                                    error.response[e].forEach((m) => {
                                        errors.push(e + ": " + m);
                                    });
                                });
                            } catch {
                                errors.push("An unexpected error has occured. Please try again or call support if the problem persists.");
                            }
                        }
                    } else {
                        errors.push("An unexpected error has occured. Please try again or call support if the problem persists.");
                    }
                    reject(errors);
                    return [];
                },
            })
        );
    });
};

export const getAuditLog = (farmId, budgetId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Budget",
            action: "Get Audit Log",
        });
        return dispatch(
            api.get({
                path: `farms/${farmId}/budgets/${budgetId}/auditlog`,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
            })
        );
    });
};

export const getAnalysisComparison = (farmId, fromAnalysisId, toAnalysisId) => (dispatch) => {
    const cancelActionType = `compareAnalyses/${farmId}/${fromAnalysisId}`;
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Budget",
            action: "Compare by Id",
        });
        dispatch({ type: cancelActionType });
        return dispatch(
            api.get({
                path: `farms/${farmId}/budgets/${fromAnalysisId}/compare/${toAnalysisId}`,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
                cancelActionType,
            })
        );
    });
};

export const getAnalysisComparisonByJson = (farmId, fromAnalysis, toAnalysis) => (dispatch) => {
    const cancelActionType = `compareJsonAnalyses`;
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Budget",
            action: "Compare by Json",
        });
        dispatch({ type: cancelActionType });
        return dispatch(
            api.post({
                path: "compare/budgets",
                content: {
                    farmId,
                    fromBudget: fromAnalysis,
                    toBudget: toAnalysis,
                },
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
                cancelActionType,
            })
        );
    });
};

export const getFarmGroups = (farmId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Farm",
            action: "Get Farm Groups",
        });
        return dispatch(
            api.get({
                path: `farms/${farmId}/farmGroups`,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject(error);
                    return [];
                },
            })
        );
    });
};

export const getDeletedAnalyses = (farmId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Farm Home",
            action: "Get Deleted Analyses",
        });
        return dispatch(
            api.get({
                path: `farms/${farmId}/deletedBudgets`,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
            })
        );
    });
};

export const getSmapUpdates = (farmId, analysisId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Budget",
            action: "S-Map Update Check",
        });
        dispatch(
            api.get({
                path: `farms/${farmId}/budgets/${analysisId}/smapUpdates`,
                timeout: 600000,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
            })
        );
    });
};

export const updateSoils = (farmId, analysisId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Budget",
            action: "Update Soils",
        });
        dispatch(
            api.put({
                path: `farms/${farmId}/budgets/${analysisId}/smapUpdates`,
                onSuccess: (response) => {
                    resolve(response);
                    return (dispatch) => {
                        dispatch(fetchFarm(farmId, true, null));
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
            })
        );
    });
};
